module.exports = __webpack_public_path__ + "img/uy.fb46025c.png";